import styled, { css } from 'styled-components'
import { Box } from '@material-ui/core'

export const WrapperBox = styled(Box)`
	max-width: 100vw;
	overflow: hidden;
	.wrapper-box-common-auth {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.wrapper-image {
		border-radius: 24px;
		overflow: hidden;
		height: calc(100vh - 48px);
		width: calc(50vw - 48px);
		@media (max-width: 1111px) {
			height: calc(-128px + 100vh);
		}
		&.unitedAnesthesia {
			display: flex;
			justify-content: center;
			align-items: center;

			img {
				object-fit: cover;
				width: 950px;
				height: auto;
			}

			@media (max-width: 1700px) {
				img {
					object-fit: cover;
					width: 800px;
					height: auto;
				}
			}

			@media (max-width: 1420px) {
				img {
					object-fit: cover;
					width: 700px;
					height: auto;
				}
			}
			@media (max-width: 1300px) {
				img {
					object-fit: cover;
					width: 550px;
					height: auto;
				}
			}
			@media (max-width: 1000px) {
				img {
					object-fit: cover;
					width: 500px;
					height: auto;
				}
			}
		}
	}
`
export const headerBarStyle = css`
	height: 90px;
	background-color: ${({ theme }) => theme.palette.common.white};
	color: ${({ theme }) => theme.palette.text.primary};
	box-shadow: unset;
	& > div > div {
		padding: 0px;
	}
	.top-bar-ano-button {
		width: 106px;
		margin: 0 5px;
	}
`

export const backButtonStyle = css`
	position: absolute;
	top: 7px;
	left: 0;
	padding: 0;
	color: ${({ theme }) => theme.palette.text.secondary};
`

export const rightButtonStyle = css`
	padding: 0;
	position: absolute;
	top: 15px;
	right: 20px;

	@media (max-width: 960px) {
		right: 55px;
		top: 10px;
	}
	padding: 0;
	color: ${({ theme }) => theme.palette.text.secondary}; ;
`

export const skipButtonStyle = css`
	padding: 0;
	color: ${({ theme }) => theme.palette.primary.main};
	position: absolute;
	top: 18px;
	right: 7px;
	text-transform: capitalize;
	cursor: pointer;
	font-weight: 600;
`

export const contentWrapper = css`
	@media (min-width: 960px) {
		padding: 0 12px;
	}
`

export const footerStyle = css`
	height: 74px;
	background-color: ${({ theme }) => theme.palette.common.white};
	border-top: 1px solid ${({ theme }) => theme.colors.content.medium};
	width: 100%;
	z-index: 999;
	.social-media-icon {
		display: flex;
		gap: 24px;
		align-items: center;
		color: ${({ theme }) => theme.colors.secondary.main};
		svg.ytb-icon {
			cursor: pointer;
			color: ${({ theme }) => theme.colors.secondary.main};
			path {
				fill: ${({ theme }) => theme.colors.secondary.main};
				stroke: ${({ theme }) => theme.colors.secondary.main};
			}
			rect {
				stroke: ${({ theme }) => theme.colors.secondary.main};
			}
		}
	}
	.text {
		${({ theme }) => theme.typography.p1};
		font-weight: 500;
		color: ${({ theme }) => theme.palette.content.dark};
	}

	${({ theme }) => theme.breakpoints.down('sm')} {
		.content-container {
			gap: 2px;
			flex-direction: column;
			justify-content: center;
		}
	}
`

export const socialWrapperStyle = css`
	display: flex;
	padding-left: 5px;
	padding-top: 5px;
	.MuiListItem-button {
		border-radius: 50px;
		width: 44px;
		height: 44px;
		padding: 0 10px 0 0 !important;
		&:hover {
			text-decoration: none;
			//background-color: rgba(0, 0, 0, 0.04);
		}
	}
	.MuiListItemIcon-root {
		padding-left: 10px;
	}
`

export const menuItemStyle = css`
  &.MuiListItem-root {
    margin: 13px 0;
  }

  &.MuiBottomNavigationAction-root {
    opacity: 0.5;
  }

  .MuiListItemIcon-root {
    min-width: 40px;
  }

  .MuiListItemText-root {
    .MuiTypography-root {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.2px;
      color: ${({ theme }) => theme.palette.content.dark};
    }
  }

  &.MuiListItem-root.Mui-selected {
    .MuiListItemText-root {
      &.mobile-responsive {
        .MuiTypography-root {
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 18px;
          letter-spacing: 0.2px;
          color: ${({ theme }) => theme.palette.content.veryLight};
            //color: ${({ theme }) => theme.palette.background.element.light};
        }
      }

      .MuiTypography-root {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.2px;

        color: ${({ theme }) => theme.palette.content.veryLight};
      }
    }

    .MuiListItemIcon-root {
      &.mobile-responsive {
        color: ${({ theme }) => theme.palette.primary.main};
      !important;
      }

      color: ${({ theme }) => theme.palette.content.veryLight} !important;
    }
  }
`

export const breadcumbsStyle = css`
	padding: 10px 6%;
	border-top: 1px solid #e6e6e6;
	background: ${({ theme }) => theme.palette.background.app.light};
	min-height: 22px;
	.root-item {
		display: flex;
		align-items: center;
		color: ${({ theme }) => theme.colors.secondary.main};
	}
	.member-item {
		cursor: pointer;
		color: ${({ theme }) => theme.colors.secondary.main};
		${({ theme }) => theme.typography.p1};
	}
	.MuiBreadcrumbs-li:last-child .text {
		color: ${({ theme }) => theme.colors.content.veryDark};
	}
	.text {
		${({ theme }) => theme.typography.p1};
	}
`
